<!--
  Vencord WebInstaller, a web frontend for the Vencord Installer
  Copyright (c) 2023 Vendicated, Justice Almanzar and Vencord contributors
  SPDX-License-Identifier: GPL-3.0-or-later
-->

<img src="/icon.png" alt="Vencord Icon" />

<style>
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
